import { Component, OnInit } from '@angular/core';
import { GeneralService } from '../../services/general.service';
import { SessionStateService } from '../../../core/services/session-state.service';

@Component({
  selector: 'app-no-devices',
  templateUrl: './no-devices.component.html',
  styleUrls: ['./no-devices.component.scss']
})
export class NoDevicesComponent implements OnInit {

  constructor(private generalService: GeneralService,
              private sessionStateService: SessionStateService) { }

  ngOnInit() {
  }

  goToDevicesAbout(): void {
    if (this.sessionStateService.getLang() === 'EN') {
      window.open('https://www.edp.pt/particulares/servicos/redy-en/kits');
    } else if (this.sessionStateService.getLang() === 'PT') {
      window.open('https://www.edp.pt/particulares/servicos/redy/kits/');
    } else if (this.sessionStateService.getLang() === 'ES') {
      window.open('https://www.edp.pt/particulares/servicos/redy-es/kits');
    } else {
      // Default
      window.open('https://www.edp.pt/particulares/servicos/redy-en/kits');
    }
  }

}




// WEBPACK FOOTER //
// ./src/app/shared/components/no-devices/no-devices.component.ts